import { HeroRoadmapForm, RoadmapForm } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import styles from './HeroSection.module.scss';
import AnimatedTitle from '../../../components/AnimatedTitle';
import Img from '../../../components/Img';
import SurveyBlock from '../../../components/SurveySection/SurveyBlock';

type AltHeroSectionData = Omit<HeroRoadmapForm, '__component' | 'positionNumber'>;

const AltHeroSection = ({ data }: { data: AltHeroSectionData }) => (
  <section className={classNames(styles.heroSection, {
    [styles.altView]: true,
  })}
  >
    <div className={classNames(styles.heroSectionContent, 'container', 'home-page')}>
      <div className={styles.descriptionBlock}>
        <div className={styles.text}>
          <h1 className={styles.title}><AnimatedTitle title={data.title} /></h1>
        </div>
        {!!data.teamImages?.length && (
          <div className={styles.altImages}>
            {data.teamImages.map(image => (
              <Img
                key={image.id}
                src={image.url}
                width={image.width}
                height={80}
                className={styles.heroAltImage}
                alt='decoration image'
              />
            ))}
          </div>
        )}
      </div>
      <SurveyBlock
        questions={data.questions as RoadmapForm['tabs']}
        formView
      />
    </div>
    <svg className={styles.heroDecoration}>
      <use
        href='/media/Home/Hero/hero_ellipse.svg#homeHeroEllipseSVG'
        xlinkHref='/media/Home/Hero/hero_ellipse.svg#homeHeroEllipseSVG'
      />
    </svg>
  </section>
);

export default AltHeroSection;
